import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  inject,
} from '@angular/core';
import { AuthService, Permission } from './auth.service';

@Directive({
  selector: '[appPermission]',
})
export class PermissionDirective {
  private tmpl = inject(TemplateRef<any>);
  private viewContainer = inject(ViewContainerRef);
  private permissions = inject(AuthService);
  private ctx: { entity: string; flag?: keyof Permission } = { entity: '' };

  @Input('appPermission') set input(
    val: { entity: string; flag?: keyof Permission } | string,
  ) {
    // console.log('PermissionDirective input:', val);
    if (typeof val === 'string') {
      this.ctx = { entity: val, flag: 'canview' };
    } else {
      this.ctx = { entity: val.entity, flag: val.flag || 'canview' };
    }
    this.render();
  }
  constructor() {}
  private render() {
    this.viewContainer.clear();
    // console.log(this.permissions);
    if (this.permissions.has(this.ctx.entity, this.ctx.flag)) {
      this.viewContainer.createEmbeddedView(this.tmpl);
    }
  }
}
